import React from "react"

import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { FloatingActionBarElement } from "../../../elements/floatingActionBar.element"

import plusIcon from "@front-shared/assets/images/icons/plus-white.svg"
import refreshIcon from "@front-shared/assets/images/icons/refresh-dark2.svg"

export const CsvReviewFloatingControlComponent: React.FunctionComponent<
    ICsvReviewFloatingControlComponentProps
> = props => {
    return (
        <FloatingActionBarElement className="gap-[8px]">
            <div className="flex items-center gap-[8px] flex-shrink-0">
                <span
                    className={`
                        flex-shrink-0 w-[20px] h-[20px] rounded-full flex items-center justify-center text-white text-[12px] font-bold
                        ${props.invalidCount ? "bg-brand-error2" : "bg-brand-green3"}
                    `}
                    aria-hidden
                >
                    {props.invalidCount ? "!" : "✓"}
                </span>

                <PrimaryText
                    typography="text"
                    size={14}
                    className="whitespace-nowrap"
                >
                    <span className="text-bold">
                        {props.invalidCount || props.validCount} of{" "}
                        {props.totalCount} row
                        {props.totalCount > 1 ? "s" : ""}
                    </span>{" "}
                    {(props.invalidCount || props.validCount) === 1
                        ? "is"
                        : "are"}{" "}
                    {props.invalidCount ? "invalid" : "valid"}
                </PrimaryText>
            </div>

            <div className="flex items-center gap-[8px] flex-shrink-0">
                <ButtonElement
                    label="Re-upload CSV"
                    htmlType="button"
                    type="default"
                    onClick={props.onReuploadCsv}
                    icon={refreshIcon}
                    buttonClassName="!pl-[16px] !pr-[16px]"
                />

                {props.validCount ? (
                    <>
                        <ButtonElement
                            label={`Add ${props.validCount}`}
                            htmlType="button"
                            type="primary"
                            onClick={props.onAddValidRows}
                            isLoading={props.isSubmitting}
                            icon={plusIcon}
                            buttonClassName="!pl-[16px] !pr-[16px]"
                        />

                        {props.onReplaceValidRows && (
                            <ButtonElement
                                label={`Replace with ${props.validCount}`}
                                htmlType="button"
                                type="default"
                                onClick={props.onReplaceValidRows}
                                isLoading={props.isSubmitting}
                                buttonClassName="!pl-[16px] !pr-[16px]"
                            />
                        )}
                    </>
                ) : null}
            </div>
        </FloatingActionBarElement>
    )
}

interface ICsvReviewFloatingControlComponentProps {
    invalidCount: number
    totalCount: number
    validCount: number
    onReuploadCsv: () => void
    onAddValidRows: () => void
    onReplaceValidRows?: () => void
    isSubmitting?: boolean
}
